<!-- Доменная конфигурация общего прогресса ЭТрН. -->
<template>
  <EdoDocumentFlowDetails
    :flow="flow"
    :title-details="titleDetails"
    :additional-title-details="additionalTitleDetails"
    :read-only="readOnly"
    :inspectable="inspectable"
    :variant="variant"
    title="Информация по этапам ЭТрН"
    :guides="stepGuides"
    :fallback-guide="fallbackGuide"
    @title-action="$emit('title-action', $event)"
  />
</template>

<script>
import {
  ETRN_FALLBACK_GUIDE,
  ETRN_STEP_GUIDES,
} from "@/components/Edo/ConsignmentNote/flowGuides";
import EdoDocumentFlowDetails from "@/components/Edo/shared/EdoDocumentFlowDetails.vue";

export default {
  name: "EdoConsignmentNoteFlowDetails",

  emits: ["title-action"],

  components: {
    EdoDocumentFlowDetails,
  },

  props: {
    flow: {
      type: Object,
      default: null,
    },
    titleDetails: {
      type: Array,
      default: () => [],
    },
    additionalTitleDetails: {
      type: Array,
      default: () => [],
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    inspectable: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: "card",
      validator: (value) => ["card", "embedded", "flat"].includes(value),
    },
  },

  computed: {
    stepGuides() {
      return ETRN_STEP_GUIDES;
    },

    fallbackGuide() {
      return ETRN_FALLBACK_GUIDE;
    },
  },
};
</script>
